<template>
  <div>
    <v-dialog
      :value="true"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      transition="slide-y-reverse-transition"
      max-width="800"
      scrollable
      persistent
    >
      <ContactForm
        :contact="editedContact"
        :errors="contactValidationErrors"
        :disabled="savingContact"
        @clear:errors="clearContactValidationErrors"
        @cancel="$router.push({ name: 'contacts' })"
        @save="onSave"
        @preview="onPreview"
        @upload:image="onImageUpload"
        @delete:image="onImageDelete"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { mapErrorsToInputs } from '@/util/forms.js';
import ContactForm from '../../components/ContactForm';
import store from '../../store';

export default {
  name: 'EditContact',

  components: { ContactForm },

  computed: mapState('contacts', ['editedContact', 'contactValidationErrors', 'savingContact']),

  beforeRouteEnter(to, from, next) {
    store
      .dispatch('contacts/editContact', to.params.id)
      .then(() => {
        next();
      })
      .catch(() => {
        next({ name: 'contacts' });
      });
  },

  methods: {
    ...mapActions('contacts', [
      'updateContact',
      'clearContactValidationErrors',
      'uploadContactImage',
      'deleteContactImage',
    ]),
    ...mapMutations('contacts', ['SET_CONTACT_VALIDATION_ERRORS']),

    onImageUpload(image, type, modelType, modelId) {
      this.uploadContactImage({
        image,
        type,
        modelType,
        modelId,
      }).catch((err) => {
        const errors = mapErrorsToInputs(err);
        this.SET_CONTACT_VALIDATION_ERRORS({ ...this.contactValidationErrors, ...errors });
        throw err;
      });
    },

    onImageDelete(image) {
      this.deleteContactImage(image);
    },

    onSave(contact) {
      this.updateContact(contact).then(() => {
        this.$router.push({ name: 'contacts' });
      });
    },

    onPreview(contact) {
      this.updateContact(contact).then(() => {
        window.open(this.$previewBackendUrl('kontaktai?'));
      });
    },
  },
};
</script>
